function disableScrolling(element) {
    element.classList.add('locked');
}
function enableScrolling(element) {
    element.classList.remove('locked');
}

/**
 * This feature is used to disable and enable scrolling
 * 
 * @class Scrolling
 */

export default class Scrolling {
    constructor() {
        if (!document.documentElement) {
            throw new Error('Document element does not exist');
        }

        this.document = document.documentElement;

        const head = document.head || document.querySelector('head');
        this.head = head || null;

    }

    disable() {
        disableScrolling(this.document);
    }

    enable() {
        enableScrolling(this.document);
    }
}

/**
 * Usage example
 * 
 * import Scrolling from 'utils/class/scrolling';
 * 
 * const scrolling = new Scrolling();
 * 
 * scrolling.disable();
 * scrolling.enable();
 * 
 */
